// --------------------Quick Fixes----------------------//

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const bars = `
  <svg xmlns="http://www.w3.org/2000/svg" fill="#011043" height="32" width="32" viewBox="0 0 640 640"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M96 160C96 142.3 110.3 128 128 128L512 128C529.7 128 544 142.3 544 160C544 177.7 529.7 192 512 192L128 192C110.3 192 96 177.7 96 160zM96 320C96 302.3 110.3 288 128 288L512 288C529.7 288 544 302.3 544 320C544 337.7 529.7 352 512 352L128 352C110.3 352 96 337.7 96 320zM544 480C544 497.7 529.7 512 512 512L128 512C110.3 512 96 497.7 96 480C96 462.3 110.3 448 128 448L512 448C529.7 448 544 462.3 544 480z"/></svg>`;
  navToggle.html(bars);
  navToggle.attr('tabindex', '0');
  navToggle.attr('role', 'button');
  navToggle.attr('aria-label', 'open menu');
}

function searchBoxPlaceholder() {
  const searchInput = $('header .inputFieldTextbox');
  // set a placeholder to searchInput
  searchInput.val('');
  searchInput.attr('placeholder', 'SEARCH');
}

// --------------------Lineup modifier----------------------//

function modifyFeatureLineup() {
  function lineupButtonsGrid(lineup) {
    const containerSize = lineup.width();
    const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const buttons = buttonContainer.find('.featureLineup-buynow');

    // if icons length + buttons length is greater than containerSize then add class "grid" to buttonContainer

    if (icons.width() + buttons.width() + 10 >= containerSize) {
      buttonContainer.addClass('column');
    }

    // remove icons if there 0 children
    if (!icons.children().length) {
      icons.remove();
    }
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

// --------------------Signup Module----------------------//

function modifySignup() {
  const signupWidget = $('.emailSignup');
  const title = `<h3>Hear It First</h3>`;
  const label =
    'Don’t be left behind! Sign up today for the latest entertainment and live music updates and get them delivered to your inbox!';
  const signupText = signupWidget.find('.emailSignupText');
  const input = signupWidget.find('.inputFieldTextbox');
  const submit = signupWidget.find('.emailSubmitButton');

  signupText.wrap('<div class="emailSignupTextContainer"></div>');
  signupText.text(label);
  $('.emailSignupTextContainer').prepend(title);
  input.val('');
  input.attr('placeholder', 'Email Address');
  submit.text('SUBSCRIBE');
  submit.attr('aria-label', 'Subscribe to newsletter');
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  modifyBtnNavToggle();
  searchBoxPlaceholder();
  modifySignup();

  // if is not homepage then modify featureLineup
  if (!$('body').hasClass('homepage')) {
    modifyFeatureLineup();
  }
});

$(window).load(() => {
  // ---
});
